export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind, Message} from 'kpc';
import type {SenderAttachment} from 'kpc';

interface Props {
    value?: string
    attachments?: SenderAttachment[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: '', attachments: []};
    }

    @bind
    onUploadError(error: Error) {
        Message.error(error.message);
    }
}